import type fetchAirbnbSyncErrors from '../../../../hosting-server/src/booking/functions/fetchAirbnbSyncErrors';
import { createServerQueryHook } from '../../core/hooks/serverHooksCreators';

const useAirbnbSyncErrors = createServerQueryHook<
    typeof fetchAirbnbSyncErrors
>('fetchAirbnbSyncErrors');

export default useAirbnbSyncErrors;
